import Vue from 'vue/dist/vue.esm';
import Vuex from 'vuex';
import setAsap from 'setasap';
import UserStore from '../user_store';
import CompanyStore from '../company_store';
import VacancyStore from '../vacancy_store';
import ResponsesStore from '../responses_store';
import InnerNavbarStore from '../inner_navbar_store';

// eslint-disable-next-line no-underscore-dangle
Promise._immediateFn = setAsap;

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    UserStore,
    CompanyStore,
    VacancyStore,
    ResponsesStore,
    InnerNavbarStore,
  },
});

export default store;
